import type { ScenarioTargetChannel } from 'api/scenarios';
import { ELineChannelStatus } from 'types';

export const ALL_ACCOUNTS_LABEL = '全アカウント';
export const NO_ACCOUNTS_LABEL = '対象アカウントなし';

export type TargetAccount = { id: number; label: string; status?: ELineChannelStatus };
export type ScenarioTargets = { allAccounts: boolean; accounts: TargetAccount[] };
/** 一覧の1行など、幅が限られる場所で先頭1件＋残件数へ畳んだ表示。 */
export type TargetSummary = { lead: string; more: number; title: string };

/** 一覧itemはstatusを持たず、detailだけが停止理由表示用のstatusを持つ。 */
type TargetSource = {
  targetsAllAccounts: boolean;
  lineChannels: Array<ScenarioTargetChannel & { status?: ELineChannelStatus }>;
};

/** basicIdは@付きで保存されている組織とそうでない組織があるため、LINE管理画面と同じ@付き表記へ揃える。 */
export function accountText(account: Pick<ScenarioTargetChannel, 'basicId' | 'memo'>) {
  return `@${account.basicId.replace(/^@/, '')}${account.memo ? `（${account.memo}）` : ''}`;
}

/** 送信できる状態のアカウントか。statusを持たない一覧itemでは判定しない。 */
export const usableAccount = (status?: ELineChannelStatus) => status === ELineChannelStatus.ACTIVE || status === ELineChannelStatus.FULL;

/** 全アカウント対象では対象行を持たないので、対象アカウントを必ず空にして取り違えを防ぐ。 */
export function resolveTargets({ targetsAllAccounts, lineChannels }: TargetSource): ScenarioTargets {
  if (targetsAllAccounts) return { allAccounts: true, accounts: [] };
  return {
    allAccounts: false,
    accounts: lineChannels.map((account) => ({ id: account.id, label: accountText(account), status: account.status })),
  };
}

export function summarizeTargets({ allAccounts, accounts }: ScenarioTargets): TargetSummary {
  if (allAccounts) return { lead: ALL_ACCOUNTS_LABEL, more: 0, title: ALL_ACCOUNTS_LABEL };
  if (!accounts.length) return { lead: NO_ACCOUNTS_LABEL, more: 0, title: NO_ACCOUNTS_LABEL };
  return { lead: accounts[0].label, more: accounts.length - 1, title: accounts.map(({ label }) => label).join('、') };
}
